<script>
  import IMask from "imask";
  import { z } from "zod";
  import Modal from "./Modal.svelte";
  import { CountyCodesIsoA2 } from "../../../../../src/Support/CountryCodes.ts";
  const createSessionRuleSchema = z.discriminatedUnion("type", [
    z.object({
      type: z.literal("ip"),
      ip: z.string().min(10),
      comment: z.string().default(""),
      duration: z.number(),
    }),

    z.object({
      type: z.literal("country"),
      country: z.string().min(2).max(2),
      comment: z.string().default(""),
      duration: z.number(),
    }),
  ]);

  let { showModal } = $props();
  let hasError = $state(null);

  let isLoading = $state(null);
  let inputIpMask = $state(null);

  let type = $state(null);
  let country = $state("");
  let ip = $state("");
  let comment = $state("");
  let duration = $state(null);

  $effect(() => {
    if (inputIpMask !== undefined && inputIpMask !== null) {
      IMask(inputIpMask, {
        mask: "000.000.000.000",
      });
    }
  });

  $effect(() => {
    showModal;
    if (!showModal) {
      type = null;
      country = "";
      ip = "";
    }
  });

  $effect(() => {
    type;
    country = "";
    ip = "";
  });

  async function submit() {
    isLoading = true;
    let payload = {
      type,
      comment,
      duration,
    };

    switch (type) {
      case "ip":
        payload["ip"] = ip;
        break;
      case "country":
        payload["country"] = country;
        break;
    }

    try {
      const validPayload = createSessionRuleSchema.parse(payload);
      const r = await window.api.admin.createSessionRule.mutate(validPayload);
      if(r['id'] !== undefined && typeof r['id'] == "number") {
        // Good Boy
        showModal = false;
      } else {
        hasError = "Something went wrong, contact your system administrator."
      }
    } catch (error) {
        hasError = JSON.parse(error.message)[0].message
    }

    isLoading = false;
  }
</script>

<Modal bind:showModal title="Create Rule">
  <div class="modal-body">
    <div class="mb-3">
      <div class="form-label">Rule Type</div>
      <select class="form-select" bind:value={type}>
        <option value="country">Country Rule</option>
        <option value="ip">IP Rule</option>
      </select>
    </div>

    {#if type != null}
      <label class="form-label" for="1">Rule Settings</label>

      <fieldset class="form-fieldset">
        {#if type == "country"}
          <div class="mb-3">
            <label class="form-label" for="3">Country</label>
            <select class="form-select" bind:value={country}>
              {#each Object.entries(CountyCodesIsoA2) as [iso, country]}
                <option value={iso}>{country}</option>
              {/each}
            </select>
          </div>
        {/if}

        {#if type == "ip"}
          <div class="mb-3">
            <label class="form-label" for="4">IP Address</label>
            <input
              bind:this={inputIpMask}
              bind:value={ip}
              type="text"
              name="input-mask"
              class="form-control"
              placeholder="000.000.000.000"
              autocomplete="off"
            />
          </div>
        {/if}

        <div class="mb-3">
          <label class="form-label" for="2">Expiry Duration</label>
          <input type="number" class="form-control" bind:value={duration} />
          <span class="form-check-description">
            How long it will take in seconds before the session expires.
          </span>
        </div>

        <div class="mb-3">
          <label class="form-label" for="2">Comment</label>
          <textarea
            bind:value={comment}
            class="form-control"
            name="example-textarea-input"
            rows="6"
            placeholder="What is the rule for?"
          ></textarea>
        </div>
      </fieldset>
    {/if}
  </div>

  <div class="modal-footer">
    <div class="ms-auto d-flex align-items-center">
      {#if hasError}
        <p class="text-danger m-0 me-2">{hasError}</p>
      {/if}

      <button class="btn btn-success" onclick={submit} disabled={isLoading}
        >Create</button
      >
    </div>
  </div>
</Modal>
